import type { FileQuerySchema } from '@/_schemas/file';

export function fileFormToUpdate(objArr?: FileQuerySchema[] | null) {
  return objArr?.map((item) => item.id) ?? [];
}
